module.exports = __webpack_public_path__ + "static/media/rakesly_rg.e5b313ca.ttf";